import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ISubscription } from '@rfm/shared-interfaces';
import { BlockUIModule } from 'ng-block-ui';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { CommonComponent } from '../../../../../lib/components/index.mjs';
import { BoolToTextPipe } from '../../../../../lib/pipes/bool-to-text.pipe.mjs';
import { SubscriptionService } from '../../../../shared/services/products/subscription.service.mjs';

@Component({
  selector: 'app-subscription-card',
  standalone: true,
  imports: [CommonModule, BlockUIModule, CardModule, TableModule, BoolToTextPipe],
  templateUrl: './subscription-card.component.html',
  styleUrls: ['./subscription-card.component.scss'],
})
export class SubscriptionCardComponent
  extends CommonComponent
{
  @Input()
  subscriptions: ISubscription[] = [];

  constructor(protected subscriptionService: SubscriptionService, protected router: Router) {
    super();
  }

    selectedSubscription: ISubscription | undefined;
  
    rowSelected()
    {
      console.log("Customer", this.selectedSubscription);
      this.router.navigate(['/admin/customers/view/', this.selectedSubscription?.id]);
    }

}
